import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TenantsListPageDto } from 'app/api/models/tenant/tenantsListPageDto';
import { AuthRepository } from 'app/state/auth.repository';
import { IConfirm } from 'app/state/tenants.repository';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrls: ['./tenant-list.component.scss'],
  standalone: false,
})
export class TenantListComponent implements OnInit {
  @Input() innerWidth = 0;
  @Input() set tenants(items: TenantsListPageDto[]) {
    this.initTenants = items;
    this.originalTenants = items;
  }
  @Input() isDeleteDisabled = true;
  @Output() delete = new EventEmitter<string>();
  @Output() clone = new EventEmitter<IConfirm>();
  deleteConfirmation: TenantsListPageDto | null = null;
  cloneConfirmation: TenantsListPageDto | null = null;
  initTenants: TenantsListPageDto[] = [];
  originalTenants: TenantsListPageDto[] = [];
  descriptions: any[] = [];

  @Input() viewMode: 'list' | 'card' = 'list';
  filterGroup = 'allTenants';
  sortField: 'name' | 'created' | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(public auth: AuthRepository) {}

  ngOnInit(): void {}

  handleDeleteClick(tenant: TenantsListPageDto) {
    if (!this.isDeleteDisabled) {
      this.delete.emit(tenant.id);
    }
  }

  getInitials(name: string): string {
    return name
      .split(' ')
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join('');
  }

  onPin(tenant: TenantsListPageDto) {
    tenant.pinned = !tenant.pinned;
    this.applyFilters();
  }

  onSort(field: 'name' | 'created') {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
    this.applyFilters();
  }

  applyFilters() {
    const pinned = this.originalTenants.filter((t) => t.pinned);
    const unpinned = this.originalTenants.filter((t) => !t.pinned);
    const sorted = [...pinned, ...unpinned];

    if (this.sortField) {
      sorted.sort((a, b) => {
        const valA = this.sortField === 'name' ? a.name : a.createdAt;
        const valB = this.sortField === 'name' ? b.name : b.createdAt;

        if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
        if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }

    this.initTenants = sorted;
  }

  formatText(text: string): string {
    return text.toLowerCase().replace(/\s+/g, '-');
  }
}
